import React, { useEffect,useRef,  useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { languageFields } from "../../hooks/LanguageFields";

const CategorySearchDropdown = ({
  categories = [],
  value,
  onChange,
  placeholder = "Search or select category",
}) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const wrapperRef = useRef(null);
  const inputRef = useRef(null);

  const selected = categories.find(
    (c) => c._id === value || c.id === value
  );

  const filteredCategories = useMemo(() => {
    return categories.filter((c) =>
      c.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [categories, search]);

  // category dropdown outside handler
  useEffect(() => {
    const handleOutside = (e) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target)
      ) {
        setOpen(false);
        if (selected) {
          setSearch(selected.name);
        }
      }
    };

    document.addEventListener("mousedown", handleOutside);

    return () => {
      document.removeEventListener(
        "mousedown",
        handleOutside
      );
    };
  }, [selected]);

  useEffect(() => {
    if (selected) {
      setSearch(selected.name);
    }
  }, [selected]);

  return (
    <div
      className="category-select-wrapper"
      ref={wrapperRef}
    >
      <div
        className={`category-select-input-box ${open ? "active" : ""
          }`}
        onClick={() => {
          setOpen(true);

          setTimeout(() => {
            inputRef.current?.focus();
          }, 100);
        }}
      >
        <i className="fas fa-search search-icon"></i>

        <input
          ref={inputRef}
          type="text"
          value={search}
          placeholder={placeholder}
          className="category-select-input"
          onFocus={() => setOpen(true)}
          onChange={(e) => {
            setSearch(e.target.value);
            setOpen(true);
          }}
        />

        <i
          className={`fas fa-chevron-down dropdown-arrow ${open ? "rotate" : ""
            }`}
        ></i>
      </div>

      {open && (
        <div className="category-dropdown-menu">
          {filteredCategories.length === 0 ? (
            <div className="category-empty">
              No category found
            </div>
          ) : (
            filteredCategories.map((c) => {
              const id = c._id || c.id;
              const isActive = value === id;

              return (
                <div
                  key={id}
                  className={`category-item ${isActive ? "selected" : ""
                    }`}
                  onClick={() => {
                    onChange(id);
                    setSearch(c.name);
                    setOpen(false);
                  }}
                >
                  <span>
                    {languageFields(c, "name", i18n)}
                    {/* {c.name} */}
                  </span>
                  {isActive && (
                    <i className="fas fa-check"></i>
                  )}
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default CategorySearchDropdown;